// extracted by mini-css-extract-plugin
module.exports = {"teaser":"ProductContent_teaser__1dkYh"};